module.exports = __webpack_public_path__ + "img/StatusWebVsVessel.d98a80c2.png";